import { z } from 'zod'
import { ResponseSuccessSchema } from '../api'
import { isDefined } from '../../util/isEmpty'
import { NotificationItemSchema } from './model'

export const NotificationListOutputSchema = z.object({
  ...ResponseSuccessSchema.shape,
  items: NotificationItemSchema.array(),
  nextCursor: z.string().nullable(),
})
export const NotificationUnreadCountOutputSchema = z.object({
  ...ResponseSuccessSchema.shape,
  count: z.number().int().nonnegative(),
  display: z.string().regex(/^(?:\d|[1-9]\d|99\+)$/),
})
const NotificationReadIdsOutputSchema = z
  .object({
    ...ResponseSuccessSchema.shape,
    items: NotificationItemSchema.array(),
    updatedCount: z.number().int().nonnegative().describe('Number changed by this call, excluding unchanged rows.'),
  })
  .strict()
const NotificationReadAllOutputSchema = z
  .object({
    ...ResponseSuccessSchema.shape,
    items: NotificationItemSchema.array().length(0).describe('All mode returns no rows.'),
    updatedCount: z.number().int().nonnegative().describe('Number changed by this call, excluding rows already read.'),
    hasMore: z.boolean().describe('More rows may remain; repeat with nextCursor until hasMore is false.'),
    nextCursor: z
      .string()
      .nullable()
      .describe('Opaque continuation; pass it as cursor with the same before and topic. Null when hasMore is false.'),
  })
  .refine((output) => output.hasMore === isDefined(output.nextCursor), {
    message: 'nextCursor must be present exactly when hasMore is true.',
  })
export const NotificationReadOutputSchema = z.union([NotificationReadIdsOutputSchema, NotificationReadAllOutputSchema])
export const NotificationArchiveOutputSchema = z.object({
  ...ResponseSuccessSchema.shape,
  items: NotificationItemSchema.array(),
  updatedCount: z.number().int().nonnegative().describe('Number changed by this call, excluding unchanged rows.'),
})
export type NotificationListOutput = z.infer<typeof NotificationListOutputSchema>
export type NotificationUnreadCountOutput = z.infer<typeof NotificationUnreadCountOutputSchema>
export type NotificationReadOutput = z.infer<typeof NotificationReadOutputSchema>
export type NotificationArchiveOutput = z.infer<typeof NotificationArchiveOutputSchema>
